import { Component, OnInit, Injector, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AppComponentBase } from '../../services/AppComponentBase';
import { Tournament } from '../../api/DixApiClient';
import { challengeTabsParams, challengeTabsList } from './challenge.tab.list';
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";

@Component({
  selector: 'app-challenges',
  template: require('./challenges.component.html'),
  styles: [require('./challenges.component.scss')]
})
export class ChallengesComponent extends AppComponentBase implements  OnInit, AfterViewInit {

  
  @ViewChild('allList') allList!: ElementRef;

  constructor( injector: Injector) {

    super(injector);

    //this.workspace.getAllTournaments();

    this.globaGridMode.loadedTournaments.subscribe((v)=>{
    
      this.currentTournaments  = this.workspace.currentTournaments; 
      this.lastTournaments  = this.workspace.lastTournaments; 
      this.upcomingTournaments  = this.workspace.upcomingTournaments;
      
      console.log("[this.currentTournaments]");
      console.log([this.currentTournaments]);
    //  console.log("[this.lastTournaments]");
   //   console.log([this.lastTournaments]);
     // console.log([this.upcomingTournaments]);



    })

   }


  public get ActiveTab()
  {
    return this.workspace.challengeActiveTab;
  }



  ngOnInit() {
  }

  ngAfterViewInit()
  {
    this.initScroll();
  }






  public _currentTournaments: Tournament[] = [];
  public get currentTournaments (): Tournament[] {
    return this._currentTournaments;
  }
  public set currentTournaments ( value: Tournament[] ) {
    this._currentTournaments = value;
  }


  public _upcomingTournaments: Tournament[] = [];
  public get upcomingTournaments (): Tournament[] {
    return this._upcomingTournaments;
  }
  public set upcomingTournaments ( value: Tournament[] ) {
    this._upcomingTournaments = value;
  }


  public _lastTournaments: Tournament[] = [];
  public get lastTournaments (): Tournament[] {
    return this._lastTournaments;
  }
  public set lastTournaments ( value: Tournament[] ) {
    this._lastTournaments = value;
  }











  public initScroll()
  {
    $(this.allList.nativeElement).mCustomScrollbar({
        axis: "y",
        theme: "inset-3", // "minimal-dark",
        scrollbarPosition: "outside",
        alwaysShowScrollbar: 0, // 0,1,2
        scrollButtons: {
            enable: true
        },
        mouseWheel: {
            enable: true
        }
    });
  }

}
